import React from "react";

const { useState, useCallback } = React;

const useOnboarding = () => {
  const [onboarding, setOnboarding] = useState({
    steps: {},
    id: undefined,
    journey: [],
  });
  const [currentPosition, setCurrentPosition] = useState(0);

  const setInitialOnboarding = useCallback(
    (newOnboarding) => {
      const initialCurrentStep =
        newOnboarding.steps[newOnboarding.journey[currentPosition]];

      const completeOnboarding = {
        ...newOnboarding,
        currentStep: initialCurrentStep,
      };

      setOnboarding(completeOnboarding);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  function nextStep(answerValue) {
    const nextJourney = onboarding?.currentStep?.nextJourney?.[answerValue];
    const currentStepId = onboarding.currentStep.id;
    const { steps } = onboarding;
    let { journey } = onboarding;

    if (nextJourney) {
      if (nextJourney.length > 0) {
        journey = getNewJourney({
          oldJourney: journey,
          nextJourney,
          currentStepId,
          currentStepPosition: currentPosition,
        });
      }
    }

    const nextCurrentStep = getNextStep({
      currentStepId,
      journey,
      steps,
      currentStepPosition: currentPosition,
    });

    if (nextCurrentStep) {
      setCurrentPosition(currentPosition + 1);

      setOnboarding({
        ...onboarding,
        journey,
        currentStep: nextCurrentStep,
      });
    } else {
      // clear user data stored on browser
      Object.keys(sessionStorage)
        .filter((variable) => variable.match(/^(CUSTOM_VARIABLE_).*/g))
        .forEach((key) => sessionStorage.removeItem(key));
      redirect(onboarding.finalURL);
    }
  }

  return {
    onboarding,
    setInitialOnboarding,
    nextStep,
    currentPosition,
  };
};

export default useOnboarding;

function redirect(url) {
  window.location.href = url;
}

function getNewJourney({ oldJourney, nextJourney, currentStepId, currentStepPosition }) {
  const pastJourney = oldJourney.slice();

  pastJourney.splice(
    currentStepPosition + 1,
    oldJourney.length - currentStepPosition + 1,
  );

  const newJourney = [...pastJourney, ...nextJourney];

  return newJourney;
}

function getNextStep({ currentStepId, journey, steps, currentStepPosition }) {
  const nextCurrentStepId = journey[currentStepPosition + 1];

  return steps[nextCurrentStepId];
}
